import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHeartFilled = () => {
  return (
    <g>
      <path d="m14.7192 2.48a4.1282 4.1282 0 0 0 -5.84 0l-.8809.88-.8809-.88a4.1294 4.1294 0 0 0 -5.84 5.84l6.19 6.1909a.7509.7509 0 0 0 1.0615 0l6.1903-6.1909a4.1282 4.1282 0 0 0 0-5.84z" />
    </g>
  );
};

export default withIcon(IconHeartFilled);
